import {Component, Input, OnInit} from "@angular/core";
import {DecimalPipe} from "@angular/common";
import {WarmwassercheckAnfrage} from "../anfrage/warmwassercheck.anfrage";
import {WarmwassercheckConstants} from "../warmwassercheck.constants";


@Component({
    selector: 'app-ergebnis-empfehlungen',
    templateUrl: './ergebnis.empfehlungen.component.html',
    providers: [DecimalPipe],
    standalone: false
})

export class ErgebnisEmpfehlungenComponent implements OnInit {

  /**
   * get warmwassercheck anfrage
   */
  @Input() anfrage: WarmwassercheckAnfrage;

  /**
   * holds all the recommendations
   */
  recommendations: any = {};

  /**
   * holds all the placeholder
   */
  textPlaceholder: any = {};

  /**
   * textkey prefix
   */
  textkeyPrefix: string = "warmwassercheck.ergebnis.empfehlungen.";

  protected readonly WarmwassercheckConstants = WarmwassercheckConstants;

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.textPlaceholder = this.anfrage?.result?.placeholder?? null;
    this.recommendations = this.anfrage?.result?.placeholder?.recommendations?? null;
  }
}
